<template>
  <KTTable
    title="Fuente Alta"
    subtitle="Lista de Fuente Alta"
    :fields="fields"
    :endpoint="endpoint"
    :delete="DELETE_FUENTE_ALTA"
    @edit="editItem($event)"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";
import { DELETE_FUENTE_ALTA } from "@/core/services/store/fuenteAlta.module";

export default {
  name: "dashboard",
  components: { KTTable },
  data() {
    return {
      DELETE_FUENTE_ALTA,
      endpoint: "dic_fuente_altas_modif",
      fields: [
        {
          key: "id_fuente",
          label: "Código Fuente Alta",
          sortable: true
        },
        {
          key: "descripcion",
          label: "Lieral Fuente Alta",
          sortable: true
        },
        {
          key: "actions",
          label: ""
        }
      ]
    };
  },
  methods: {
    editItem(item) {
      this.$router.push(`${this.$route.path}/${item.id_fuente}`);
    }
  }
};
</script>
